import type { AvailabilityPage as CoreAvailabilityPage } from "@b2bportal/core-hotels";
import { useHotelSlot } from "@b2bportal/core-hotels";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Icon, Button } from "@tenant/ui";
import styles from "./styles.module.scss";

const COMPONENT_KEY = "MapAndFilterButtonGroup";

export const MapAndFilterButtonGroup = (
  props: React.ComponentProps<
    typeof CoreAvailabilityPage
  >["context"]["shopModeConfig"]
) => {
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const HotelSlot = useHotelSlot();

  return (
    <div role="group" className={block}>
      <Button onClick={props.onClick} className={cn("map-button")}>
        <Icon iconName={props.icon} />
        {props.text}
      </Button>
      <HotelSlot.FilterDialog />
    </div>
  );
};
